import alt from '../alt';
import generateWithAsyncActions from 'epic-alt-utils';

/**
 * SubscriptionActions
 */
export default generateWithAsyncActions(alt, [
    'subscribeEmail'
], []);
